import { render } from "./ChooseProduct.vue?vue&type=template&id=6c5cb2c6&scoped=true&ts=true"
import script from "./ChooseProduct.vue?vue&type=script&lang=ts"
export * from "./ChooseProduct.vue?vue&type=script&lang=ts"

import "./ChooseProduct.vue?vue&type=style&index=0&id=6c5cb2c6&scoped=true&lang=css"
import "./ChooseProduct.vue?vue&type=style&index=1&id=6c5cb2c6&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5cb2c6"]])

export default __exports__